import axios, {AxiosInstance} from "axios";
import "./HttpErrorPresentation.ts";
import {notifyError} from "./ErrorNotification.ts";

export const baseUrl = "/api";

const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d*)?(?:Z|[+-]\d{2}:?\d{2})?$/;

export function createHttpClient(baseURL = baseUrl): AxiosInstance {
    const client = axios.create({baseURL, timeout: 10_000});
    client.interceptors.response.use(response => ({
        ...response,
        data: parseDates(response.data),
    }), error => {
        // Existing forms and loading views own their errors until they are migrated.
        if (!axios.isCancel(error) && error.response?.status !== 401
            && error.config?.errorPresentation === "toast") {
            notifyError(error, error.config.errorMessage);
        }
        return Promise.reject(error);
    });
    return client;
}

function parseDates(value: unknown): unknown {
    if (typeof value === "string") return isoDateFormat.test(value) ? new Date(value) : value;
    if (Array.isArray(value)) return value.map(parseDates);
    if (!isPlainObject(value)) return value;
    return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, parseDates(entry)]));
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
    if (value === null || typeof value !== "object") return false;
    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}

export const http = createHttpClient();
